import { CONNECT, DISCONNECT, CONNECT_ERROR, RECONNECT_FAILED } from './socketIO-mutation-types'
import store from '@/store'
import _ from 'lodash'
const getters = {
}

const state = {
  isConnected: false,
  data: null
}

const actions = {
  async SOCKET_connect ({ commit }) {
    commit(CONNECT)
  },
  async SOCKET_disconnect ({ commit }) {
    commit(DISCONNECT)
  },
  async SOCKET_newMessageReceived ({ commit }, { data }) {
    store.dispatch('message/appendMessage', { data })
  },
  async SOCKET_newMessageSent ({ commit }, { data }) {
    store.dispatch('message/appendMessage', { data })
  },
  async SOCKET_newMassMessageSent ({ commit }, { data }) {
    store.dispatch('message/appendMessage', { data })
  },
  async SOCKET_updateMessageEmit ({ commit }) {
  },
  async SOCKET_error ({ commit }) {
    commit(CONNECT_ERROR)
  },
  async SOCKET_connect_error ({ commit }) {
    commit(CONNECT_ERROR)
  },
  async SOCKET_reconnect_failed ({ commit }) {
    commit(RECONNECT_FAILED)
  }
}

const mutations = {
  [CONNECT] (state) {
    state.isConnected = true
  },
  [DISCONNECT] (state) {
    state.isConnected = false
    store.dispatch('message/setLoadingStatus', { val: false })
  },
  [CONNECT_ERROR] (state) {
    console.error('socket io connection error')
    store.dispatch('message/setLoadingStatus', { val: false })
    store.dispatch('alert/error', 'Socket IO Connect Error')
  },
  [RECONNECT_FAILED] (state) {
    store.dispatch('message/setLoadingStatus', { val: false })
    store.dispatch('alert/error', 'Socket IO Reconnect Failed')
  }
}

export const getSocket = (self) => {
  return self._vm.$socket
}

export const reconnectSocket = async (socket) => {
  const authToken = store.getters['authentication/getLoginAuthToken']
  const accountSid = _.get(store.getters['account/getUser'], 'twilio_sid', '')
  socket.io.opts.query = { authToken, accountSid }
  await socket.connect()
}

export const socketIO = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
